export function ParallaxGrid() {
  const items = document.querySelectorAll(".parallax-grid__item")

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.remove("in-view", !entry.isIntersecting)
        entry.target.classList.toggle("in-view", entry.isIntersecting)
      })
    },
    {
      root: null,
    },
  )

  items.forEach((item) => {
    observer.observe(item)
  })
}
